var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.create}},[_vm._v("添加班段")]),_c('sl-table',{attrs:{"page":false,"columns":_vm.columns,"data":_vm.segData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }